module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBoldItalic.15c3b2f8.woff";